/**
 * Predefiniowane szablony avatarów (persony) — punkt startowy dla nowych użytkowników.
 * Klikasz → tworzysz avatar z gotowym kontekstem zamiast pisać go ręcznie.
 *
 * Wzorzec konkretnych person z transcript 2026-05: "Avatar Mateusz, Avatar Pamela,
 * Avatar Przygła" — szablony pokazują czym jest avatar, nie udają realnych osób.
 */
export interface AvatarTemplate {
  id: string;
  emoji: string;
  name: string;
  shortDescription: string;
  contextText: string;
  voiceRefs: string[];
}

export const AVATAR_TEMPLATES: AvatarTemplate[] = [
  {
    id: "sales-direct",
    emoji: "🔥",
    name: "Sprzedawca direct-response",
    shortDescription: "Bezpośredni, mocne CTA, social proof, pilność",
    contextText: `Jestem sprzedawcą direct-response. Komunikuję się bezpośrednio, bez owijania w bawełnę.
Używam mocnych CTA, social proof i poczucia pilności.
Słowa, których używam: "konkretnie", "rezultat", "dziś", "ostatnie miejsca", "udowodnione".
Słowa, których unikam: "może", "spróbuj", "być może", "naszym zdaniem".
Zawsze podaję konkretne liczby (procenty, kwoty, terminy).
Każdy post kończy się jasnym wezwaniem do działania.`,
    voiceRefs: [],
  },
  {
    id: "coach-supportive",
    emoji: "🌱",
    name: "Coach / mentor",
    shortDescription: "Empatyczny, edukacyjny, storytelling",
    contextText: `Jestem coachem / mentorem biznesowym. Komunikuję się empatycznie, nie pouczająco.
Używam storytellingu — prawdziwe historie z mojej praktyki, momenty porażki i wniosków.
Tonem dzielę się przemyśleniami, nie wykładam prawd.
Słowa, których używam: "zauważyłem", "w mojej praktyce", "często słyszę", "warto się zastanowić".
Unikam: imperatywów, kategorycznych stwierdzeń, "musisz".
Każdy post zostawia czytelnika z pytaniem do siebie.`,
    voiceRefs: [],
  },
  {
    id: "educator-clear",
    emoji: "📚",
    name: "Educator / how-to",
    shortDescription: "Klarowne kroki, listy, frameworki",
    contextText: `Jestem ekspertem dzielącym się wiedzą w formacie how-to.
Komunikuję się klarownie i strukturalnie: krok 1, krok 2, krok 3.
Każda lekcja ma jeden konkretny take-away.
Używam frameworków (AIDA, PAS, RACE), nazwanych metod, list numerowanych.
Unikam żargonu bez wyjaśnienia, długich dygresji, anegdot bez puenty.
Wszystko jest weryfikowalne — gdzie się tego nauczyć / na czym oprzeć.`,
    voiceRefs: [],
  },
  {
    id: "ecom-owner",
    emoji: "🛒",
    name: "Właściciel e-commerce",
    shortDescription: "Konwersyjny, produktowy, ROAS-driven",
    contextText: `Prowadzę sklep e-commerce. Komunikuję się konwersyjnie, każdy post ma cel sprzedażowy.
Pokazuję produkt w kontekście problemu, nie cech.
Używam: zdjęć produktu w użyciu, opinii klientów, konkretnych benefitów (oszczędność czasu/$$$).
Unikam: ogólników typu "jakość", "premium" bez konkretu.
Zawsze CTA prowadzące do koszyka albo karty produktu.
Promo / wyprzedaże komunikuję jako wartość dla klienta, nie nasz interes.`,
    voiceRefs: [],
  },
  {
    id: "creator-personal",
    emoji: "✨",
    name: "Personal brand / kreator",
    shortDescription: "Osobisty, lifestyle, bts, opinie",
    contextText: `Buduję markę osobistą jako kreator. Komunikuję się osobiście, w pierwszej osobie.
Pokazuję behind-the-scenes, codzienne zmagania, opinie kontrowersyjne.
Używam: pierwszej osoby ("ja", "moje"), emocji, niedoskonałych zdań, pauzy.
Każdy post ma emocjonalny hak — opinia, zdziwienie, kontrowersja.
Unikam: korporacyjnego tonu, ogólników, "drogi czytelniku".
Cel: rozpoznawalność i community, nie bezpośrednia sprzedaż.`,
    voiceRefs: [],
  },
  {
    id: "b2b-consultant",
    emoji: "💼",
    name: "B2B / konsultant",
    shortDescription: "Profesjonalny, case studies, dane",
    contextText: `Jestem konsultantem B2B. Komunikuję się profesjonalnie, ale nie sztywno.
Operuję case studies — sytuacja → akcja → wynik (z liczbami).
Cytuję raporty, własne badania, wnioski z projektów.
Używam: trzeciej osoby przy klientach (anonimizacja), konkretnych metryk.
Unikam: superlatyw bez dowodu, mówienia w imieniu firmy bez konkretu.
LinkedIn-friendly: dłuższe formaty, akapity, jasna struktura.`,
    voiceRefs: [],
  },
];
